export default __webpack_public_path__ + "static/media/powered-by-stripe.f43e0ae8.png";